export default "/images/personagem-errado.png?ee4283fc1120eca5ed7ff69c3b520daf";